import React, { useEffect } from "react";
import Highcharts from "highcharts";
import { hejriDate } from "@helpers/financial_helper";
import { fieldsColorHelper } from "@helpers/ui_helper";

const SemiCircleChart = ({ betweenDays, historicalFields, showMyPolygon }) => {
  let pointData = [];

  historicalFields?.forEach((field, index) => {
    const width = (betweenDays[index] / 1) * 100;
    pointData.push({
      name: `از تاریخ ${hejriDate(field?.createdAt)} تا ${hejriDate(
        historicalFields[index + 1]?.createdAt
      )}`,
      y: width,
      color: fieldsColorHelper(field?.productId),
    });
  });

  useEffect(() => {
    const options = {
      chart: {
        type: "pie",
        events: {
          load: function () {
            showMyPolygon(0);
          },
        },
      },

      title: {
        text: "تاریخچه زمین",
        align: "center",
        verticalAlign: "middle",
        y: -40,
      },

      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}</b>",
      },

      plotOptions: {
        pie: {
          events: {
            click: function (event) {
              showMyPolygon(event.point.index);
            },
          },

          dataLabels: {
            enabled: false,
            style: {
              color: "white", // رنگ متن
              fontSize: "12px", // اندازه فونت
              textOutline: "black", // حاشیه متن
              overflow: "visible", // نمایش کامل متن
            },
          },

          startAngle: -90,
          endAngle: 90,
          center: ["50%", "50%"],
          size: "100%",
        },
      },

      series: [
        {
          name: "مدت زمان",
          innerSize: "86%",
          data: pointData.reverse(),
        },
      ],
    };
    Highcharts.chart("circle-chart", options);
  }, [pointData]);

  return (
    <div
      id="circle-chart"
      className="!overflow-visible max-lg:ml-6 flex max-lg:!w-[300px] max-lg:!h-[300px] items-start justify-center !w-[350px] !h-[350px]"
    />
  );
};

export default SemiCircleChart;
